<template>
  <main class="appContent">
    <TalkWithGuide v-if="talkWithGuideVisible" />
    <AppHeader />
    <div v-if="flashMessages.length">
      <div class="topbar" v-for="(message, index) in flashMessages" :key="index">
        <div class="topbarText">{{ message }}</div>
      </div>
    </div>
    <div 
      class="appBody"
      :class="{'quotePage': $route.path === '/system'}"
    >
        <transition name="component-fade" mode="out-in">
          <router-view />
        </transition>
    </div>
    <AppFooter :showChat="showChat" />
    <!-- Slideout -->
			<div class="slideout" :class="{'open': slideout.open}">
				<div class="slideoutOverlay" @click="closeSlideout"></div>
				<div class="slideoutPanel">
					<nav>
						<router-link to="/help/equipment">Equipment</router-link>
            <router-link to="/help">Help Articles</router-link>
            <a href="javascript:;" @click="showTalkWithGuide">Talk with a Guide</a>
					</nav>
          <footer>
            <h2>Want to chat?</h2>
            <p>Give us a call! <br> We are happy to help you. </p>
            <p>{{ supportNumber }}</p>
          </footer>
				</div>
				<div class="slideoutClose" @click="closeSlideout">x</div>
			</div>
			<!-- END Slideout -->
  </main>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'
import TalkWithGuide from './TalkWithGuide/TalkWithGuide.vue'
import PhoneLink from "./PhoneLink.vue";
export default {
  data: () => ({
    csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    flashMessages: window.appFlashMessages || []
  }),
  computed: {
    ...mapState([
      'slideout',
      'supportNumber',
      'supportNumberLink',
      'talkWithGuideVisible',
      'user'
    ])
  },
  methods: {
    ...mapActions(['closeSlideout', 'showChat']),
    ...mapMutations([
      'toggleTalkWithGuideVisible'
    ]),
    showTalkWithGuide() {
      this.closeSlideout()
      this.toggleTalkWithGuideVisible()
    },
  },
  components: {
    AppHeader,
    AppFooter,
    PhoneLink,
    TalkWithGuide
  }
}
</script>

<style lang="css">

</style>
